import { useURL } from '@/composables/useURL'
import type { Locale } from 'lc-services/types'

export const getApiURL = ({
  config,
  locale,
}: {
  config: ReturnType<typeof useRuntimeConfig>
  locale: Locale
}) => {
  const { getApiURL } = useURL()

  return getApiURL({ locale, path: config.public.apiPrefix })
}
